import TabButton from "./TabButton";

const TabButtonsList = ({ activeTab, setActiveTab, onScrollTo }) => {
  const tabs = [
    { key: "about", label: "درباره‌ی پزشک" },
    { key: "services", label: "خدمات" },
    { key: "specialities", label: "تخصص‌ها" },
    { key: "contact", label: "اطلاعات تماس" },
  ];

  return (
    <div className="flex gap-[5px] xl:gap-2 sticky top-0 z-20">
      {tabs.map((tab) => (
        <TabButton
          key={tab.key}
          text={tab.label}
          isActive={activeTab === tab.key}
          onClick={() => {
            setActiveTab(tab.key);
            onScrollTo(tab.key);
          }}
        />
      ))}
    </div>
  );
};

export default TabButtonsList;
